import { Row } from "antd";
import { Conversations } from "./Conversations";
import { ISelectedConversation } from "../../../../types/SelectedConversation";

type AccountsProps = {
  data: any[];
  conversation: ISelectedConversation | null;
  readConversation: (
    contractNumber: number,
    selectedConvValues: ISelectedConversation
  ) => void;
};

export const Accounts = ({
  data,
  conversation,
  readConversation,
}: AccountsProps) => {
  return (
    <Row className="d-block w-100 mb-6">
      {data.map((item: any, i: number) => (
        <Row className="d-block" key={i}>
          <Conversations
            propertyAddress={item.propertyAddress}
            contractNumber={item.contractNumber}
            data={item.conversations}
            conversation={conversation}
            readConversation={readConversation}
          />
        </Row>
      ))}
    </Row>
  );
};
